module.exports = __webpack_public_path__ + "static/media/BC_Jacquard_Vela_White.d91aa095.png";